import React from 'react';
import { Row, Col } from "react-flexbox-grid";
import styled from "styled-components";

const border = {
    borderSize : '1px',
    borderStyle: 'solid',
    borderColor: '#0CA0DA',
}
const ipscss = {
    marginLeft: '0px',
    marginRight: '0px'
}
const PreEFormMappingHeader = () =>
    <Row style={ipscss}
className="tasklist--row"
    >
    <Col lg={8} className="tasklist--description" style={{border}}>
<div><strong>IPS Location Name</strong></div>
</Col>
</Row>

export default PreEFormMappingHeader;